export const tableColumns = [
    {
        title: "backoffice.languages.name",
        dataIndex: "name",
        sorter: true,
        alwaysVisible: true,
        mobileLevel: 1,
    },
    {
        title: "backoffice.languages.code",
        dataIndex: "code",
        sorter: true,
        mobileLevel: 3,
    },
    {
        title: "backoffice.languages.createdAt",
        dataIndex: "createdAt",
        isDateTime: true,
        sorter: true,
        mobileLevel: 2,
    }
];